import { isValid, parseISO } from "date-fns";

/**
 * Derives app `lastPublishedAt` from the HTTP `Last-Modified` response header on
 * `GET /data/maritime/warnings`.
 *
 * KNMI sets this header to the publication time of the current warnings dataset,
 * including when the JSON body is an empty array. Per HTTP, the header may be omitted;
 * that is not a separate application state — callers receive `undefined` and the UI
 * should degrade gracefully (e.g. existing “geen informatie” copy).
 *
 * Parse failures are non-fatal and also yield `undefined`.
 */
export function parseLastPublishedAtFromHeader(
  lastModifiedHeader: string | undefined,
): string | undefined {
  const raw = lastModifiedHeader?.trim();
  if (!raw) return undefined;

  try {
    const fromIso = parseISO(raw);
    if (isValid(fromIso)) return fromIso.toISOString();

    const fromHttpDate = new Date(raw);
    if (isValid(fromHttpDate)) return fromHttpDate.toISOString();
  } catch {
    return undefined;
  }

  return undefined;
}
